module.exports = __webpack_public_path__ + "img/contact-form-image-01.667ad74a.png";